const searchParamValue = (traffic, key) => {
  const urlObject = new URL(traffic.url.toLowerCase())
  return urlObject.searchParams.get(key)
}

export default searchParamValue



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/selectors/searchParamValue.js